/*
 * Task Type Credentials - handle credential collection for a subscription.
 */
import React, { Component } from 'react';
//import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, TextField, Typography } from '@mui/material';
import PasswordInput from '../ui/PasswordInput';
// import SaveButton from '../ui/SaveButton';
import AppBindStyles from '../../AppBindStyles';
import { getValueForRender } from '../../utils/InputUtils';

const styleSheet = theme => ({
  labelField: {
    width: 80,
  },
  emailField: {
    minWidth: 336,
  },
  additionalFields: {
    minWidth: 336,
  },
  iconButton: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2,
  },
  iconButtonAction: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 3,
    paddingBottom: 2,
  },
  iconButtonRightMargin: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2,
    marginRight: 36,
  },
});

class TaskTypeAuth extends Component {

  constructor(props) {
    super(props);

    this.state = {
      unencryptPwd:         null,
      unencryptPwdChanged:  false,
      domain:               null,
      username:             null,
      pwd:                  null,
      useEmail:             null,
      forceFetch:           0,
      saveStatus:           null,
      saveMessage:          null,
      saveSnackbarOpen:     false,
      saveSnackbarDuration: null
    };
  }

  componentDidMount() {
    let theTask         = this.props.task;
    let theSubscription = theTask.customerAppTByCustomerAppId;

    if (this.props.setCompleteDisabled) {
      // Check based on the initial values from the subscription that was passed in.
      let parentCompleteDisabled = this.props.isCompleteDisabled();

      let stateCompleteDisabled = this.isCompleteDisabled(theSubscription.useEmail, theSubscription.pwd, theSubscription.domain, theSubscription.username);
  
      if (parentCompleteDisabled !== stateCompleteDisabled) {
        this.props.setCompleteDisabled(stateCompleteDisabled);
      }

      this.setState({userEmail: theSubscription.useEmail, domain: theSubscription.domain, pwd: theSubscription.pwd, username: theSubscription.username});
    }
  }

  setUnencryptedPassword(value) {
    this.setState({unencryptPwdChanged: true, unencryptPwd: value});
    this.checkCompleteDisabled("password", value);
  }

  handleDoneFromParent () {
    const { callPartnerApi, encryptOneTimeEncryptedValue } = this.props.auth;

    let theTask         = this.props.task;
    let theSubscription = theTask.customerAppTByCustomerAppId;
    //let theApp          = theSubscription.appTByAppId;

    let taskData = theTask.taskData;
    let theEmail = null;
    if (taskData.email === true) {
      theEmail = this.state.useEmail;
    }
    let thePwd = null;
    if (taskData.password === true) {
      thePwd = this.state.unencryptPwd;
    }
    let theDomain = null;
    if (taskData.domain === true) {
      theDomain = this.state.domain;
    }
    let theUsername = null;
    if (taskData.username === true) {
      theUsername = this.state.username;
    }

    let unencryptPwdChanged = this.state.unencryptPwdChanged;
    let unencryptPwd = this.state.unencryptPwd;

    return new Promise(function(resolve, reject) {
      let theResponse = {
        status: -1,
        message: 'Unidentified error'
      };

      Promise.resolve()
      .then(() => {
        if (unencryptPwdChanged === true && thePwd != null && thePwd.length > 0) {
          // console.log('encrypting password');
          // encrypt
          return encryptOneTimeEncryptedValue(unencryptPwd, callPartnerApi);
        } else {
          return null;
        }
      })
      .then((jresp) => {
        if (jresp != null && jresp.status === 0) {
          let theKeyId = jresp.keyId;
          let encryptedData = jresp.encryptedData;
  
          //console.log('theKeyId=' + theKeyId);
  
          let payload = {
            operation: "updateSubscription",
            params: {
              "usingAccountId": theSubscription.customerAccountId,
              "provisioningAccountId": theSubscription.provisioningAccountId,
              "customerAppId": theSubscription.customerAppId,
              "keyId": theKeyId,
              "encryptedData": encryptedData,
              "appStatus": null,
              "appSkuPrice": null, 
              "appMarkupPercentage": null, 
              "appMarkupAbsolute": null, 
              "notes": null,
              "paymentOrder": null,
              "useEmail": theEmail,
              "shareCredentials": null, 
              "showSubscription": null, 
              "passThroughFees": null, 
              "wholesaleDiscountPercentage": null, 
              "domain": theDomain, 
              "username": theUsername,
              "forwardingEmailList": null
            }
          }
  
          return callPartnerApi('appbind/generic',
                                'POST',
                                  payload);
        } else {
          let payload = {
            operation: "updateSubscription",
            params: {
              "usingAccountId": theSubscription.customerAccountId,
              "provisioningAccountId": theSubscription.provisioningAccountId,
              "customerAppId": theSubscription.customerAppId,
              "unencryptedString": thePwd,
              "appStatus": null,
              "appSkuPrice": null, 
              "appMarkupPercentage": null, 
              "appMarkupAbsolute": null, 
              "notes": null,
              "paymentOrder": null,
              "useEmail": theEmail,
              "shareCredentials": null, 
              "showSubscription": null, 
              "passThroughFees": null, 
              "wholesaleDiscountPercentage": null, 
              "domain": theDomain, 
              "username": theUsername,
              "forwardingEmailList": null
  
            }
          }
  
          return callPartnerApi('appbind/generic',
                                'POST',
                                  payload);
        }
      }).then(()=> {
        theResponse.status = 0;
        theResponse.message = 'Success';
        resolve(theResponse);
        return;
      })
      .catch(error => {
        theResponse.status = -2;
        theResponse.message = 'Error: ' + JSON.stringify(error);
        reject(theResponse);
        return;
      });
    });
  }

  setStateAttribute = (attribute, value) => {
    this.setState({[attribute]: value});
    if (this.props.setCompleteDisabled && this.props.isCompleteDisabled) {
      this.checkCompleteDisabled(attribute, value);
    }
  }

  checkCompleteDisabled(changedAttribute, value) {
    // Values to check.
    let useEmail = this.state.useEmail;
    if (changedAttribute === 'useEmail') {
      useEmail = value;
    }
    // Password is a special case, as we simply want to detect if there is some value set.
    let password = this.state.pwd;
    if (password == null || password.length < 1) {
      password = this.state.unencryptPwd;
    }
    if (changedAttribute === 'password') {
      password = value;
    }
    let domain = this.state.domain;
    if (changedAttribute === 'domain') {
      domain = value;
    }
    let username = this.state.username;
    if (changedAttribute === 'username') {
      username = value;
    }

    // Parent state
    let parentCompleteDisabled = this.props.isCompleteDisabled();

    let stateCompleteDisabled = this.isCompleteDisabled(useEmail, password, domain, username);

    if (parentCompleteDisabled !== stateCompleteDisabled) {
      this.props.setCompleteDisabled(stateCompleteDisabled);
    }
  }

  isCompleteDisabled(email, password, domain, username) {
    const { validateEmail } = this.props.auth;

    let theTask = this.props.task;
    let taskData = theTask.taskData;
    let showEmail = false;
    if (taskData.email === true) {
      showEmail = true;
    }
    let showPassword = false;
    if (taskData.password === true) {
      showPassword = true;
    }
    let showDomain = false;
    if (taskData.domain === true) {
      showDomain = true;
    }
    let showUsername = false;
    if (taskData.username === true) {
      showUsername = true;
    }

    // Email
    if (showEmail === true) {
      if (email == null || email.length < 5) {
        return true;
      }
      if (validateEmail(email) === false) {
        return true;
      }
    }

    // Password
    if (showPassword === true) {
      if (password == null || password.length < 4) {
        return true;
      }
    }
    // domain
    if (showDomain === true) {
      if (domain == null || domain.length < 1) {
        return true;
      }
    }
    // username
    if (showUsername === true) {
      if (username == null || username.length < 1) {
        return true;
      }
    }

    return false;  
  }

  render() {
    const classes = this.props.classes;

    let theTask         = this.props.task;
    let theTitle        = theTask.title;
    let theInstruction  = theTask.instruction;
    let theSubscription = theTask.customerAppTByCustomerAppId;
    let theApp          = theSubscription.appTByAppId;

    let theUsePwdVal   = getValueForRender(this.state.pwd, theSubscription.pwd, '');
    let theUseEmailVal = getValueForRender(this.state.useEmail, theSubscription.useEmail, '');
    let theDomainVal   = getValueForRender(this.state.domain, theSubscription.domain, '');
    let theUsernameVal = getValueForRender(this.state.username, theSubscription.username, '');

    // console.log('theUsePwdVal=' + theUsePwdVal);

    let readOnly = false;
    if (this.props.done === true) {
      readOnly = true;
    }

    let theAppName = theTask.customerAppTByCustomerAppId.appTByAppId.appName;
    let theAccountName = theTask.customerAppTByCustomerAppId.accountTByProvisioningAccountId.accountName;

    let usePassedTitle = true;
    let theTitleStart = null;
    let theTitleCta = null;
    let theTitleEnd = null;
    if (theTitle == null || theTitle.length < 2) {
      if (theAppName != null && theAccountName != null) {
        usePassedTitle = false;
        theTitleStart = 'Please ';
        theTitleCta = 'share your ' + theAppName + ' login';
        theTitleEnd = ' with ' + theAccountName;
      } else {
        theTitle = 'Please share your login with our team';
      }
    }

    // The invite link should have a JSON object of email notes in taskData.
    let taskData = theTask.taskData;
    let showEmail = false;
    if (taskData.email === true) {
      showEmail = true;
    }
    let showPassword = false;
    if (taskData.password === true) {
      showPassword = true;
    }
    let showDomain = false;
    if (taskData.domain === true) {
      showDomain = true;
    }
    let showUsername = false;
    if (taskData.username === true) {
      showUsername = true;
    }

    let theEmailFieldId = 'your-provided-email';
    if (this.props.order) {
      theEmailFieldId = 'your-provided-email-' + this.props.order;
    }

    return (
      <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
        {this.props.title != null && this.props.title.length > 0 &&
        <Grid item xs={12}>
          <Typography variant="h6">{this.props.title}</Typography>
        </Grid>}
        {usePassedTitle === true &&
        <Grid item xs={12}>
          <Typography variant="body1">{theTitle}</Typography>
        </Grid>}
        {usePassedTitle === false &&
        <Grid item xs={12}>
          <Typography variant="body1">{theTitleStart}<strong>{theTitleCta}</strong>{theTitleEnd}</Typography>
        </Grid>}
        {theInstruction != null && theInstruction.length > 0 &&
        <Grid item xs={12}>
          <Typography variant="body2">{theInstruction}</Typography>
        </Grid>}

        {/* Domain */}
        {(showDomain === true) &&
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
            <Grid item className={classes.labelField}>
              <Typography variant="body1" style={AppBindStyles.boldLabel}>Domain</Typography>
            </Grid>
            <Grid item>
              <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                <Grid item>
                  <TextField
                    id="domain" className={classes.additionalFields}
                    value={theDomainVal}
                    onChange={ (e) => { this.setStateAttribute("domain", e.target.value); } }
                  />
                </Grid>
                {/*<Grid item>
                  <Tooltip placement='bottom' title='Copy domain to clipboard'>
                    <IconButton
                      className={classes.iconButtonRightMargin}
                      onClick={() => {this.setClipboardVal(theDomainVal); }}
                      size="large">
                      <img alt="Copy to Clipboard" 
                          src='/images/content_copy_black_24x24.png' 
                          height="16px"/>
                    </IconButton>
                  </Tooltip>     
                </Grid>*/}
              </Grid>
            </Grid>
          </Grid>
        </Grid>}

        {/* Username */}
        {(showUsername === true) &&
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
            <Grid item className={classes.labelField}>
              <Typography variant="body1" style={AppBindStyles.boldLabel}>User name</Typography>
            </Grid>
            <Grid item>
              <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                <Grid item>
                  <TextField
                    id="username" 
                    className={classes.additionalFields}
                    value={theUsernameVal}
                    onChange={ (e) => { this.setStateAttribute("username", e.target.value); } }
                  />
                </Grid>
                {/*<Grid item>
                  <Tooltip placement='bottom' title='Copy username to clipboard'>
                    <IconButton
                      className={classes.iconButtonRightMargin}
                      onClick={() => {this.setClipboardVal(theUsernameVal); }}
                      size="large">
                      <img alt="Copy to Clipboard" 
                          src='/images/content_copy_black_24x24.png' 
                          height="16px"/>
                    </IconButton>
                  </Tooltip>     
                </Grid>*/}
              </Grid>
            </Grid>
          </Grid>
        </Grid>}

        {/* Email */}
        {(showEmail === true) &&
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
            <Grid item className={classes.labelField}>
              <Typography variant="body1" style={AppBindStyles.boldLabel}>Email</Typography>
            </Grid>
            <Grid item>
              <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                <Grid item>
                  <TextField className={classes.emailField} id={theEmailFieldId} 
                    value={theUseEmailVal}
                    disabled={readOnly}
                    onChange={(e) => { this.setStateAttribute("useEmail", e.target.value);}}
                  />
                </Grid>
                {/*<Grid item>
                  <Tooltip placement='bottom' title='Copy email to clipboard'>
                    <IconButton
                      className={classes.iconButtonRightMargin}
                      onClick={() => {this.setClipboardVal(theUseEmailVal); }}
                      size="large">
                      <img alt="Copy to Clipboard" 
                          src='/images/content_copy_black_24x24.png' 
                          height="16px"/>
                    </IconButton>
                  </Tooltip>     
                </Grid>*/}
              </Grid>
            </Grid>
          </Grid>
        </Grid>}

        {/* Password */}
        {(showPassword === true) &&
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
            <Grid item className={classes.labelField}>
              <Typography variant="body1" style={AppBindStyles.boldLabel}>Password</Typography>
            </Grid>
            <Grid item>
              <PasswordInput
                name="password"
                auth={this.props.auth}
                customerAppId={theSubscription.customerAppId}
                pwd={theUsePwdVal}
                basicDisplay={true}
                disabled={readOnly}
                readOnly={readOnly}
                onChange={(e) => {this.setUnencryptedPassword(e)}}
              />
            </Grid>
          </Grid>
        </Grid>}

      </Grid>
    );
  }
}

TaskTypeAuth.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(TaskTypeAuth);;
